export default __webpack_public_path__ + "static/logo-escola-arabe-3fecfaa7a7b2884c86da71a76b26aa12.svg";